export default {
  title: 'Dato og tid',
  buttons: {
    done: 'Færdig',
  },
};
